(function () {
  const installInsuranceStore = () => {
    if (!window.Alpine || Alpine.store('xPopupInsurance')) return;

    Alpine.store('xPopupInsurance', {
      open: false,
      loading: false,
      openInsuranceNoti: false,
      openInsuranceNotification() {
        this.openInsuranceNoti = true;
        window.setTimeout(() => {
          this.openInsuranceNoti = false;
        }, 5000);
      }
    });
  };

  if (window.Eurus && window.Eurus.loadedScript) {
    window.Eurus.loadedScript.add('product-insurance.js');
  }

  document.addEventListener('alpine:init', installInsuranceStore, { once: true });
  document.addEventListener('alpine:initialized', installInsuranceStore, { once: true });

  if (window.Alpine) installInsuranceStore();
})();
